const isoToShortMap: Record<string, string> = {
  'sv-SE': 'sv',
  'en-GB': 'en',
  'nb-NO': 'nb',
  'nn-NO': 'nn',
  'fi-FI': 'fi',
};

const useLegacyLanguageMap = () => {
  const isoCodeToShortCode = (iso: string): string => isoToShortMap[iso];
  return { isoCodeToShortCode };
};

export default useLegacyLanguageMap;
